/* ==========================================================================
   AKRO - Code promo dans le panier deroulant
   --------------------------------------------------------------------------
   Applique un code de reduction depuis le drawer via l'Ajax Cart API :
     POST /cart/update.js  { discount: "CODE1,CODE2" }
   (parametre `discount` supporte depuis mai 2025 - changelog Shopify).
   Le code est pose sur le PANIER, il reste donc actif jusqu'au checkout.

   TROIS PIEGES TRAITES ICI - ne pas "simplifier" sans les relire :

   1. Le drawer porte un @click.stop sur #right-drawer-slot. Un listener
      document en phase bubble ne verrait JAMAIS les clics du drawer.
      -> toute la delegation est en phase CAPTURE (3e argument = true).

   2. Le thème re-rend et "morphe" la section cart-footer a chaque
      evenement panier. Aucun binding direct sur les elements : delegation
      uniquement, l'etat visible vient du HTML rendu par Liquid.

   3. Un code invalide ou expire renvoie HTTP 200, pas une erreur. Le seul
      indicateur fiable est le flag `applicable` dans discount_codes. Et le
      code refuse RESTE stocke dans le panier -> il faut le nettoyer, sinon
      il ressort au checkout.

   Bonus : on envoie les codes deja appliques + le nouveau, pour qu'une
   saisie erronee ne fasse jamais sauter un code valide en place.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__akroPromoReady) return;
  window.__akroPromoReady = true;

  var ROOT_SEL = '[data-akro-promo]';
  var SECTIONS = 'cart-items,cart-footer,cart-item-count,cart-live-region';

  function shopRoot() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  function closestRoot(el) {
    return el && el.closest ? el.closest(ROOT_SEL) : null;
  }

  function setMessage(root, text, state) {
    var el = root.querySelector('[data-akro-promo-msg]');
    if (!el) return;
    el.textContent = text || '';
    if (state) {
      el.setAttribute('data-state', state);
    } else {
      el.removeAttribute('data-state');
    }
  }

  function setBusy(root, busy) {
    var input = root.querySelector('[data-akro-promo-input]');
    var button = root.querySelector('[data-akro-promo-submit]');
    if (busy) {
      root.setAttribute('data-loading', 'true');
    } else {
      root.removeAttribute('data-loading');
    }
    if (input) input.disabled = !!busy;
    if (button) button.disabled = !!busy;
  }

  function label(root, key, fallback) {
    return root.getAttribute('data-i18n-' + key) || fallback;
  }

  function getJSON(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json().catch(function () { return {}; });
    });
  }

  function fetchCart() {
    return getJSON(shopRoot() + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });
  }

  /* codes: tableau de chaines. withSections: demande au serveur de re-rendre
     les sections du panier pour que le thème puisse les morpher. */
  function updateDiscounts(codes, withSections) {
    var payload = { discount: codes.join(',') };
    if (withSections) {
      payload.sections = SECTIONS;
      payload.sections_url = window.location.pathname;
    }
    return getJSON(shopRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    });
  }

  function appliedCodes(cart) {
    var list = (cart && cart.discount_codes) || [];
    return list
      .filter(function (d) { return d && d.applicable; })
      .map(function (d) { return d.code; });
  }

  function same(a, b) {
    return String(a).toLowerCase() === String(b).toLowerCase();
  }

  /* Rejoue l'evenement natif du thème : cart-items, cart-footer, le compteur
     et la live region se remettent a jour tout seuls. */
  function notifyTheme(data) {
    window.dispatchEvent(
      new CustomEvent('baseline:cart:update', { detail: { response: data } })
    );
  }

  function lock() { document.dispatchEvent(new CustomEvent('baseline:cart:lock')); }
  function unlock() { document.dispatchEvent(new CustomEvent('baseline:cart:unlock')); }

  function apply(root) {
    var input = root.querySelector('[data-akro-promo-input]');
    if (!input) return;

    var code = (input.value || '').trim();
    if (!code) {
      setMessage(root, label(root, 'empty', 'Please enter a code.'), 'error');
      input.focus();
      return;
    }

    setBusy(root, true);
    setMessage(root, '', null);
    lock();

    var previous = [];

    fetchCart()
      .then(function (cart) {
        previous = appliedCodes(cart);
        var merged = previous.filter(function (c) { return !same(c, code); });
        merged.push(code);
        return updateDiscounts(merged, true);
      })
      .then(function (data) {
        var entry = ((data && data.discount_codes) || []).filter(function (d) {
          return same(d.code, code);
        })[0];

        if (entry && entry.applicable) {
          input.value = '';
          notifyTheme(data);
          return null;
        }

        /* Refuse : on retire le code fantome et on restaure l'etat precedent. */
        return updateDiscounts(previous, false).then(function () {
          setMessage(root, label(root, 'invalid', 'This code is not valid for your cart.'), 'error');
          input.select();
        });
      })
      .catch(function () {
        setMessage(root, label(root, 'error', 'Something went wrong. Please try again.'), 'error');
      })
      .then(function () {
        unlock();
        setBusy(root, false);
      });
  }

  function remove(root, code) {
    setBusy(root, true);
    setMessage(root, '', null);
    lock();

    fetchCart()
      .then(function (cart) {
        var kept = appliedCodes(cart).filter(function (c) { return !same(c, code); });
        return updateDiscounts(kept, true);
      })
      .then(function (data) {
        notifyTheme(data);
      })
      .catch(function () {
        setMessage(root, label(root, 'error', 'Something went wrong. Please try again.'), 'error');
      })
      .then(function () {
        unlock();
        setBusy(root, false);
      });
  }

  /* --- Delegation en phase CAPTURE (voir piege n.1 en tete de fichier) ----- */

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var submit = target.closest('[data-akro-promo-submit]');
      if (submit && !submit.disabled) {
        event.preventDefault();
        var root = closestRoot(submit);
        if (root) apply(root);
        return;
      }

      var removeBtn = target.closest('[data-akro-promo-remove]');
      if (removeBtn && !removeBtn.disabled) {
        event.preventDefault();
        var removeRoot = closestRoot(removeBtn);
        if (removeRoot) remove(removeRoot, removeBtn.getAttribute('data-akro-promo-remove'));
      }
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter') return;
      var target = event.target;
      if (!target || !target.closest) return;
      var input = target.closest('[data-akro-promo-input]');
      if (!input) return;
      event.preventDefault();
      var root = closestRoot(input);
      if (root) apply(root);
    },
    true
  );
})();
